/** @format */

import { ENVIROMENT } from './enviroment.constant';

const DEFAULTS = {
	magistralQuotation: true,
	pickupWhatsAppNotification: false,
	deliveryTimeSelect: true,
	sameDayDeliveryDates: false,
	sameDayWeekdayCutoffHour: 14,
	sameDaySaturdayCutoffHour: null,
	pickupDaySelect: false,
	requestRecipe: false,
	homeRedesign: false,
};

const OVERRIDES = {
	narma: { pickupWhatsAppNotification: true, deliveryTimeSelect: false },
	muygreen: { pickupWhatsAppNotification: true, deliveryTimeSelect: false, requestRecipe: true },
	fanich: {
		magistralQuotation: false,
		deliveryTimeSelect: false,
		sameDayDeliveryDates: true,
		pickupDaySelect: true,
	},
	jvf: { magistralQuotation: false },
	zupharma: {
		magistralQuotation: false,
		deliveryTimeSelect: false,
		sameDayDeliveryDates: true,
		sameDayWeekdayCutoffHour: 15,
		sameDaySaturdayCutoffHour: 13,
		homeRedesign: true,
	},
};

export const pharmacyFeatures = {
	...DEFAULTS,
	...OVERRIDES[ENVIROMENT.ROOT_PHARMACY],
};

export const isMagistralQuotationEnabled = () => pharmacyFeatures.magistralQuotation;

export const isPickupWhatsAppNotificationEnabled = () => pharmacyFeatures.pickupWhatsAppNotification;

export const isHomeRedesignEnabled = () => pharmacyFeatures.homeRedesign;
